module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_card_2.5596b880.png";